import { render, staticRenderFns } from "./IconSslCertificate.vue?vue&type=template&id=8d3e2296"
import script from "./IconSslCertificate.vue?vue&type=script&lang=js"
export * from "./IconSslCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports